<div class="main-wrapper grey">
  <div class="container" [ngClass]="{ 'pb-100': util.isMobile() }">
      <div class="footer-content" *ngFor="let item of footerContent">
        <div class="icon-wrapper">
          <mat-icon>{{item.icon}}</mat-icon>
        </div>
        <div class="content footer-font">
          <ng-container *ngIf="item.isLink; else notLink">
            <a class="footer-font" [href]="item.icon === 'call'? 'tel:' + item.content : 'mailto:' + item.content">
              {{ item.content }}
            </a>
          </ng-container>
          <ng-template #notLink>
            {{ item.content }}
          </ng-template>
        </div>
      </div>
  </div>
</div>


